/**
 * Stale-response drop utility for GlobalSearch.
 *
 * The BE echoes the query string in `echoQuery`. If the user typed faster
 * than the debounce interval, earlier responses may arrive after later ones.
 * Drop any response whose echoQuery does not match the current input.
 *
 * Design §6.1 / handover §2 "echoQuery for stale-response drop".
 */
export function shouldDropResponse(
  echoQuery: string,
  currentInput: string,
): boolean {
  return echoQuery !== currentInput;
}
